import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormat',
})
export class DurationFormatPipe implements PipeTransform {
  transform(
    value: string | number,
    format: string,
    dataType: 's' | 'ms' = 'ms'
  ): string {
    let valueInSeconds: number;
    if (typeof value === 'string') {
      // tslint:disable-next-line:radix
      value = parseInt(value);
    }

    valueInSeconds =
      dataType === 'ms' ? Math.floor(value / 1000) : Math.floor(value);
    const hours = Math.floor(valueInSeconds / 3600);
    const minutes = Math.floor((valueInSeconds - hours * 3600) / 60);
    const seconds = valueInSeconds - hours * 3600 - minutes * 60;

    return this.format(format, seconds, minutes, hours);
  }

  private format(
    format: string,
    seconds: number,
    minutes: number,
    hours: number
  ): string {
    const prefixedHours = this.prefixZero(hours);
    const prefixedMinutes = this.prefixZero(minutes);
    const prefixedSeconds = this.prefixZero(seconds);

    const foundSeparator = new RegExp(/\W+/g).exec(format);
    const separator = foundSeparator ? foundSeparator[0] : null;
    const orderedUnits = format.split(new RegExp(/\W+/g)).map((unit) => {
      switch (unit) {
        case 'h':
          return hours.toString();
        case 'hh':
          return prefixedHours;
        case 'mm':
          return prefixedMinutes;
        case 'ss':
          return prefixedSeconds;
        default:
          return unit;
      }
    });
    return orderedUnits.join(separator);
  }

  private prefixZero(unit: number): string {
    return unit < 10 ? '0' + unit : unit.toString();
  }
}
